import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { getToken, isTokenExpired, updateToken } from './keycloak';

import type { RootState } from '../store';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001/api',
  prepareHeaders: async (headers, { getState }) => {
    const state = getState() as RootState;
    const orgId = state.org?.selectedOrgId;

    if (orgId) {
      headers.set('X-Tenant-Id', orgId);
    }

    const _token = getToken();
    if (_token && !isTokenExpired()) {
      try {
        await updateToken(30);
        headers.set('Authorization', `Bearer ${getToken()!}`);
      } catch (error) {
        console.error('[apiSlice] Token refresh failed:', error);
      }
    }
    return headers;
  },
});

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  if (!getToken() || isTokenExpired()) {
    console.warn(
      '[apiSlice] Request blocked — Keycloak not yet authenticated.'
    );
    return {
      error: {
        status: 'CUSTOM_ERROR',
        error: 'Keycloak not yet authenticated',
      } as FetchBaseQueryError,
    };
  }
  return rawBaseQuery(args, api, extraOptions);
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQuery,
  tagTypes: ['Organization', 'Newsletter'],
  endpoints: () => ({}),
});
